<template>
  <el-header>
    <slot name="title"></slot>
    <div class="space"></div>
    <app-offline></app-offline>
    <app-connected-user></app-connected-user>
  </el-header>
</template>

<script>
import AppConnectedUser from '@/components/connected-user/ConnectedUser'
import AppOffline from '@/components/offline/Offline'

export default {
  name: 'AppHeader',
  components: { AppConnectedUser, AppOffline }
}
</script>

<style lang="scss" scoped>
header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: unset !important;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #DCDFE6;

  .space {
    flex: 1;
  }

  .app-connected-user {
    margin-left: 1rem;
  }
}
</style>
